import { FC, ReactNode } from 'react'
import { useUser } from '~hooks'
import EditLink from '~shared/EditLink'

import hasAdminAccess from '~utils/hasAdminAccess'
import styles from './edit-section-wrapper.module.scss'

type EditSectionWrapperProps = {
  label?: string
  children?: ReactNode
} & ({ name?: string; href: string } | { name: string; href?: string })

const EditSectionWrapper: FC<EditSectionWrapperProps> = ({
  label = 'Edit this component',
  children,
  name,
  href,
}) => {
  const [user] = useUser()

  if (!hasAdminAccess(user)) return <>{children}</>

  return (
    <div className={styles.wrapper}>
      <EditLink
        label={label}
        classes={styles.link}
        href={href}
        id={name}
        entityType="SECTION"
        color="neutral"
        size="sm"
        external
      />
      {children}
    </div>
  )
}

export default EditSectionWrapper
